import React, { ReactNode } from 'react';

import './CenteredBadgeContainer.scss';

export const CenteredListBadges = ({ children }: { children: ReactNode }) => (
    <div className="centered-badge-container">{children}</div>
);
